import styled from 'styled-components';
import colors from 'constants/colors';
import IconDelete from 'assets/icons/ic_close_white.svg';

const CardStyles = styled.div`
  width: 170px;
  height: 100px;
  margin: 0 4px;
  display: flex;
  flex: 0 0 170px;
  cursor: pointer;

  @media screen and (max-width: 992px) {
    width: 120px;
    height: 70px;
    margin: 0;
    flex: 0 0 120px;
  }
`;

export const DeleteButton = styled.i`
  position: absolute;
  right: 4px;
  top: 4px;
  height: 24px;
  width: 24px;
  background: url(${IconDelete}) 0 0 no-repeat;
  background-size: contain;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  &:before {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    width: 32px;
    height: 32px;
  }

  @media screen and (max-width: 992px) {
    opacity: 1;
  }
`;

const Card = styled(CardStyles)`
  padding: 8px 12px;
  align-items: flex-end;
  background: url(${({ src }: { src: string }) => src}) center no-repeat;
  background-size: cover;
  position: relative;

  &:before {
    content: '';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    position: absolute;
    background: linear-gradient(35deg, rgba(216, 65, 129, 0.5) 16%, rgba(14, 160, 195, 0.5) 64%);
    z-index: 0;
    transition: opacity 0.3s ease-in-out;
  }

  &:hover {
    &:before {
      opacity: 1;
    }

    ${DeleteButton} {
      opacity: 1;
    }
  }

  a:focus-visible > & {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;

    &:before {
      opacity: 1;
    }

    ${DeleteButton} {
      opacity: 1;
    }
  }

  @media screen and (max-width: 992px) {
    padding: 5px 10px;
  }
`;

const AddCard = styled(CardStyles)`
  align-items: center;
  justify-content: center;
  background-color: ${colors.main.textButtonHoverBackground};
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: ${colors.background.maincolor};
  }

  &:focus-visible {
    outline: 2px solid ${colors.main.blue};
    outline-offset: 2px;
  }
`;

const TextWrapper = styled.div`
  width: 100%;
  z-index: 1;
`;

const Icon = styled.div`
  font-size: 32px;
  font-weight: 400;
  color: ${colors.main.grey};
`;

export { Card, AddCard, TextWrapper, Icon };
